import { api } from './api';

const apiDefinitions = {
  login: async (payload) => {
    try {
      return await api.post('/auth/login', payload);
    } catch (error) {
      throw error;
    }
  },
   getMergeSuggestions: async () => {
    try {
      return await api.get('/vehicle-booking/merge-suggestions', {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
    } catch (error) {
      throw error;
    }
  },
  mergeVehicleBookingsManually: async (payload) => {
  try {
    const response = await api.post('/vehicle-booking/merge-manually', payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
        Accept: 'application/json, text/plain, */*',
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
},
getOngoingVehicleBookings: async (pageNo = 1) => {
  try {
    const res = await api.get('/vehicle-booking/ongoing', {
      params: { pageNo },
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return res; // ApiResponse<GetVehicleBookingResponse>
  } catch (error) {
    throw error;
  }
},
getMergeGroupDetailsById: async (groupId) => {
  try {
    const response = await api.get(`/vehicle-booking/merge-suggestions/${groupId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
},

cancelVehicleBookingRequest: async (reason, bookingId, groupId) => {
  try {
    const params = {
      reason,
      ...(bookingId !== null ? { bookingId: String(bookingId) } : {}),
      ...(groupId !== null ? { groupId: String(groupId) } : {}),
    };

    const token = localStorage.getItem('token');
    if (!token) throw new Error('Missing auth token');

    const response = await api.put('/vehicle-booking/cancel', null, {
      params,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response;
  } catch (error) {
    throw error;
  }
},
unmergeVehicleBookings: async (groupId) => {
  try {
    const response = await api.put(`/vehicle-booking/unmerge/${groupId}`, null, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
},

                                                                          
  getAllMergedGroups: async (statusFilter = 'ACCEPTED') => {
  try {
    const response = await api.get('/vehicle-booking/merged-groups', {
      params: { statusFilter },
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });

    return response;
  } catch (error) {
    throw error;
  }
},

  getUsers: async (pageNo, payload) => {
    try {
      return await api.post(`/user/get/${pageNo}`, payload);
    } catch (error) {
      throw error;
    }
  },
acceptMergeGroups: async (groupId, payload) => {
    try {
      return await api.post(`/vehicle-booking/merge-groups/${groupId}`, payload, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
    } catch (error) {
      throw error;
    }
  },

  rejectMergeGroups: async (groupId, payload) => {
  try {
    return await api.post(`/vehicle-booking/merge-groups/${groupId}`, payload, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
  } catch (error) {
    throw error;
  }
},
  getAvailableVehicles: async (departureTime, arrivalTime, totalNoOfPassengers) => {
  try {
    if (!departureTime || !arrivalTime || isNaN(Number(departureTime)) || isNaN(Number(arrivalTime))) {
      throw new Error('Valid departure and arrival times are required');
    }

    const params = {
      departureTime: String(departureTime),
      arrivalTime: String(arrivalTime),
      totalNoOfPassengers,
    };


    const response = await api.get('/vehicle-booking/available-vehicles', {
      params,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });

    if (response.data.status !== 'S1000') {
      throw new Error(response.data.statusDescription || 'Failed to fetch available vehicles');
    }

    return response;
  } catch (error) {
    const errorMsg = error.response?.data?.statusDescription || error.message;
    throw new Error(errorMsg);
  }
},
  getEmployees: async () => {
    return await api.get('/auth/hr/employees');
  },
  addUser: async (payload) => {
    return await api.post('/auth/hr/user/add', payload);
  },
  
  getUsersByType: async (empType, payload = {}) => {
    try {
      const endpoint = `/user/get/simple/${empType}`;
      const response = await api.post(endpoint, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json',
          Accept: 'application/json, text/plain, */*',
        },
      });
      return response;
    } catch (err) {
      throw err;
    }
    
  },
  getVehicleServiceDataById: async (serviceId) => {
  try {
    const response = await api.get(`/vehicle/service-data/get/${serviceId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
},
updateVehicleServiceApprovalStatus: async (serviceId, payload) => {
  try {
    const response = await api.put(`/vehicle/service-data/update-status/${serviceId}`, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
},


completeVehicleServiceRequest: async (serviceId, payload, billPhotos = []) => {
  try {
    const formData = new FormData();
    formData.append('request', new Blob([JSON.stringify(payload)], { type: 'application/json' }));
    billPhotos.forEach((file, index) => {
      formData.append('billPhotos', file);
    });
    const response = await api.post(`/vehicle/service-data/complete/${serviceId}`, formData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'multipart/form-data',
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
},

  getVehiclesServiceData: async (pageNo = 1, payload = {}) => {
  try {
    const endpoint = `/vehicle/service-data/get/${pageNo}`;
    
    const response = await api.post(endpoint, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
        Accept: 'application/json, text/plain, */*',
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
},
  getVehiclesALLServiceData: async (pageNo = 1, payload = {}) => {
  try {
    const endpoint = `/vehicle/service-data/get/${pageNo}`;
    
    const response = await api.post(endpoint, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
        Accept: 'application/json, text/plain, */*',
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
},
addVehiclePart: async (payload) => {
  return await api.post('/vehicle/part/add', payload);
},
getVehicleParts: async (pageNo, payload) => {
  return await api.post(`/vehicle/part/get/${pageNo}`, payload);
},


  getAllGroups: async () => {
    return await api.get('/group/get-all');
  },
  forgotPassword: async (email) => {
    return await api.post('/auth/forgot-password', email, {
      headers: { 'Content-Type': 'text/plain' },
    });
  },
  addVehicleServiceData: async (payload) => {
  return await api.post('/vehicle/service-data/add', payload);
},

  updateUser: async (payload) => {
    try {
      return await api.post("/user/update", payload);
    } catch (error) {
      throw error;
    }
  },
  verifyToken: async (token) => {
    return await api.get(`/auth/verify/${token}`);
  },
  resetPasswordWithToken: async (token, payload) => {
    return await api.post(`/auth/reset-password/${token}`, payload);
  },
  initialPasswordReset: async (payload) => {
    try {
      return await api.post('/auth/initial-reset-password', payload);
    } catch (error) {
      throw error;
    }
  },
  updatePassword: async (payload) => {
    return await api.post('/auth/update/password', payload);
  },
  adminResetUserPassword: async (payload) => {
    return await api.post('/auth/admin/reset-user-password', payload);
  },
  addLocation: async (payload) => {
    return await api.post('/auth/location/add', payload);
  },
  getLocations: async (pageNo, payload) => {
    return await api.post(`/auth/location/get/${pageNo}`, payload);
  },
  addRoom: async (payload) => {
    return await api.post('/auth/room/add', payload);
  },
  getRooms: async (pageNo, payload) => {
    return await api.post(`/auth/room/get/${pageNo}`, payload);
  },
  addVehicleBooking: async (payload) => {
    try {
      const response = await api.post('/vehicle-booking/add', payload);
      return response;
    } catch (err) {
      throw err;
    }
  },
  updateVehicleBooking: async (payload) => {
    try {
      return await api.put('/vehicle-booking/update', payload);
    } catch (error) {
      throw error;
    }
  },
  finalApproved: async (payload) => {
    try {
      return await api.get('/vehicle-booking/final-approved', payload);
    } catch (error) {
      throw error;
    }
  },

  approveVehicleBooking: async (payload) => {
    try {
      return await api.put('/vehicle-booking/approve', payload);
    } catch (error) {
      throw error;
    }
  },
  finalApproveVehicleBooking: async (payload) => {
    try {
      const response = await api.put('/vehicle-booking/final-approve', payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json',
          Accept: 'application/json, text/plain, */*',
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  getApprovedBookings: async (pageNo = 1) => {
  try {
    const response = await api.get('/vehicle-booking/approved', {
      params: { pageNo },
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
},

getAvailableDrivers: async (departureTime, arrivalTime) => {
  try {
    // Validate inputs
    if (!departureTime || isNaN(Number(departureTime))) {
      throw new Error('Valid departureTime is required');
    }
    if (!arrivalTime || isNaN(Number(arrivalTime))) {
      throw new Error('Valid arrivalTime is required');
    }

    // Ensure times are in millisecond timestamp format as strings
    const params = {
      departureTime: String(departureTime),
      arrivalTime: String(arrivalTime),
    };


    const response = await api.get('/vehicle-booking/available-drivers', {
      params,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });


    // Validate response structure
    if (response.data.status !== 'S1000') {
      throw new Error(response.data.statusDescription || 'Failed to fetch available drivers');
    }

    if (!Array.isArray(response.data?.data?.drivers)) {
      throw new Error('Invalid drivers data received from API');
    }

    return response;
  } catch (error) {
    const errorMsg = error.response?.data?.statusDescription || error.response?.data?.error || error.message;
    throw new Error(errorMsg);
  }
},
  deleteVehicleBooking: async (id) => {
    try {
      return await api.delete(`/vehicle-booking/delete/${id}`);
    } catch (error) {
      throw error;
    }
  },
  getVehicleBookingById: async (id) => {
    try {
      return await api.get(`/vehicle-booking/${id}`);
    } catch (error) {
      throw error;
    }
  },
  getVehicleBookings: async (pageNo, payload) => {
    try {
      return await api.post(`/vehicle-booking/get`, payload, {
        params: { pageNo }
      });
    } catch (error) {
      throw error;
    }
  },
  getUserCreatedBookings: async (pageNo, payload) => {
    try {
      return await api.post('/vehicle-booking/user-created-bookings', payload, {
        params: { pageNo }
      });
    } catch (error) {
      throw error;
    }
  },
  markVehicleOut: async (payload) => {
    try {
      return await api.post('/vehicle-booking/mark-out', payload);
    } catch (error) {
      throw error;
    }
  },
  markVehicleIn: async (payload) => {
    try {
      return await api.post('/vehicle-booking/mark-in', payload);
    } catch (error) {
      throw error;
    }
  },
  getDriverAllocations: async (fromDate, toDate) => {
    try {
      return await api.get('/vehicle-booking/driver-allocations', {
        params: { fromDate, toDate }
      });
    } catch (error) {
      throw error;
    }
  },
  getVehicleAllocations: async (fromDate, toDate) => {
    try {
      return await api.get('/vehicle-booking/vehicle-allocations', {
        params: { fromDate, toDate }
      });
    } catch (error) {
      throw error;
    }
  },
  getDashboardDataVehicleBooking: async () => {
    try {
      return await api.get('/vehicle-booking/dashboard');
    } catch (error) {
      throw error;
    }
  },
  getDashboardDataVehicleDistance: async (startDate, endDate) => {
    try {
      return await api.post('/vehicle-booking/dashboard/distance', { fromDate: startDate, toDate: endDate });
    } catch (error) {
      throw error;
    }
  },
  getLatestVehicleBookingId: async () => {
    try {
      return await api.get('/vehicle-booking/latest-id');
    } catch (error) {
      throw error;
    }
  },
  addRecurringBooking: async (payload) => {
    try {
      return await api.post('/vehicle-booking/recurring/add', payload);
    } catch (error) {
      throw error;
    }
  },
  cancelRecurringBooking: async (id) => {
    try {
      return await api.put(`/vehicle-booking/recurring/cancel/${id}`);
    } catch (error) {
      throw error;
    }
  },
  getSharedRideSuggestions: async (bookingId) => {
    try {
      return await api.get(`/vehicle-booking/shared-ride-suggestions/${bookingId}`);
    } catch (error) {
      throw error;
    }
  },
  getPendingApprovalBookings: async (pageNo) => {
    try {
      return await api.get('/vehicle-booking/pending-approval', {
        params: { pageNo }
      });
    } catch (error) {
      throw error;
    }
  },
  getPendingFinalApprovalBookings: async (pageNo) => {
    try {
      return await api.get('/vehicle-booking/pending-final-approval', {
        params: { pageNo }
      });
    } catch (error) {
      throw error;
    }
  },
  getUserByEmpNumber: async (empNumber) => {
  try {
    const response = await api.get(`/user/get/${empNumber}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
  
},
addLocation: async (payload) => {
  try {
    const response = await api.post('/locations/add', payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
},

getLocations: async (pageNo, payload) => {
  try {
    const response = await api.post(`/locations/get/${pageNo}`, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
},

  getCompletedBookings: async (pageNo) => {
    try {
      return await api.get('/vehicle-booking/completed', {
        params: { pageNo }
      });
    } catch (error) {
      throw error;
    }
  },
  getRejectedBookings: async (pageNo) => {
    try {
      return await api.get('/vehicle-booking/rejected', {
        params: { pageNo }
      });
    } catch (error) {
      throw error;
    }
  },
  notifyNoVehicleAvailability: async (bookingId) => {
    try {
      return await api.post(`/vehicle-booking/notify-no-availability/${bookingId}`);
    } catch (error) {
      throw error;
    }
  },
  // Location APIs (Key Management)
getLocationById: async (id) => {
  try {
    const response = await api.get(`/locations/get-id/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
},

getLocationByName: async (name) => {
  try {
    const response = await api.get(`/locations/get-name/${name}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
},

updateLocation: async (payload) => {
  try {
    const response = await api.put('/locations/update', payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
},

deleteLocation: async (id) => {
  try {
    const response = await api.delete(`/locations/delete/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
},

  addVehicleBrand: async (payload) => {
    return await api.post('/vehicle-brand-model/add', payload);
  },
  getVehicleBrandModelById: async (id) => {
    return await api.get(`/vehicle-brand-model/get-one/${id}`);
  },
  deleteVehicleModel: async (payload) => {
    return await api.post('/vehicle-brand-model/delete/model', payload);
  },
  deleteVehicleBrand: async (payload) => {
    return await api.post('/vehicle-brand-model/delete/brand', payload);
  },
  addVehicleModel: async (payload) => {
    return await api.post('/vehicle-brand-model/update', payload);
  },
  getVehicleBrandModels: async (pageNo, payload) => {
    return await api.post(`/vehicle-brand-model/get/${pageNo}`, payload);
  },
  loadVehicleConfig: async () => {
    return await api.get('/vehicle/load/config');
  },
  addVehicle: async (payload) => {
    return await api.post('/vehicle/add', payload);
  },
  updateVehicle: async (payload) => {
    return await api.post('/vehicle/update', payload);
  },
  addVehicleServiceData: async (payload) => {
    return await api.post('/vehicle/service-data/add', payload);
  },
  updateVehicleServiceData: async (payload) => {
    return await api.post('/vehicle/service-data/update', payload);
  },
  getVehicles: async (pageNo = 1, payload = {}) => {
    try {
      const endpoint = '/vehicle/get-all';
      const response = await api.get(endpoint, {
        params: { pageNo },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json',
          Accept: 'application/json, text/plain, */*',
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
    getVehicleByNumberPlate: async (numberPlate) => {
    try {
      return await api.get(`/vehicle/get/${numberPlate}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
    } catch (error) {
      throw error;
    }
  },
  getVehicleServiceData: async (pageNo, payload) => {
    return await api.post(`/vehicle/service-data/get/${pageNo}`, payload);
  },
  getVehicleAllocations: async (payload) => {
    return await api.post('/vehicle/get/allocations', payload);
  },
  getSimpleVehicles: async (payload) => {
    return await api.post('/vehicle/get/simple', payload);
  },
  addVehiclePart: async (payload) => {
    return await api.post('/vehicle/part/add', payload);
  },
  getVehicleParts: async (pageNo, payload) => {
    return await api.post(`/vehicle/part/get/${pageNo}`, payload);
  },
  getDashboardDataVehicleService: async () => {
    return await api.get('/vehicle/get/dashboard-data-vehicle-service');
  },
  getDashboardDataVehicleServiceCost: async (payload) => {
    return await api.post('/vehicle/get/dashboard-data-vehicle-service-cost', payload);
  },
  createVehicleType: async (payload) => {
    return await api.post('/vehicle-type/add', payload);
  },
  getAllVehicleTypes: async () => {
    return await api.get('/vehicle-type/getAll');
  },
  deleteVehicleType: async (id) => {
    return await api.delete(`/vehicle-type/delete/${id}`);
  },
  addVehicleFeature: async (payload) => {
    return await api.post('/vehicle-feature/add', payload);
  },
  getAllVehicleFeatures: async () => {
    return await api.get('/vehicle-feature/all');
  },
  deleteVehicleFeature: async (id) => {
    return await api.delete(`/vehicle-feature/delete/${id}`);
  },
  uploadVehicleImages: async (numberPlate, formData) => {
    return await api.post(`/vehicle/${numberPlate}/images`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  uploadRegistrationBookImages: async (numberPlate, formData) => {
    return await api.post(`/vehicle/${numberPlate}/registration-book-images`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  addEmissionTest: async (payload, formData = new FormData()) => {
    formData.append('request', new Blob([JSON.stringify(payload)], { type: 'application/json' }));
    return await api.post('/vehicle-emission-test/add', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  uploadEmissionTestImages: async (numberPlate, formData) => {
    Array.from(formData.entries()).forEach(([key, value]) => {
     
    });
    return await api.post(`/vehicle-emission-test/add`, formData, {
      headers: { 'Content-Type': 'image/png' },
    });
  },
  addRevenueLicence: async (payload, formData = new FormData()) => {
    formData.append('request', new Blob([JSON.stringify(payload)], { type: 'application/json' }));
    return await api.post('/vehicle-revenue-licences/add', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  uploadRevenueLicenceImages: async (numberPlate, formData) => {
    Array.from(formData.entries()).forEach(([key, value]) => {
     
    });
    return await api.post(`/vehicle-revenue-licences/add`, formData, {
      headers: { 'Content-Type': 'image/png' },
    });
  },
  addVehInsurance: async (payload) => {
    return await api.post('/vehicle-insurance/add', payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  addVehRevenueLicence: async (payload) => {
    return await api.post('/vehicle-revenue-licences/add', payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  addVehEmissionTest: async (payload) => {
    return await api.post('/vehicle-emission-test/add', payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  addInsurance: async (payload, formData = new FormData()) => {
    formData.append('request', new Blob([JSON.stringify(payload)], { type: 'application/json' }));
    return await api.post('/vehicle-insurance/add', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  uploadInsuranceImages: async (numberPlate, formData) => {
    Array.from(formData.entries()).forEach(([key, value]) => {
    });
    return await api.post(`/vehicle-insurance/add`, formData, {
      headers: { 'Content-Type': 'image/png' },
    });
  },
  getLatestEmissionTests: async () => {
    return await api.get('/vehicle-emission-test/latest-all');
  },
  getEmissionTestById: async (id) => {
    return await api.get(`/vehicle-emission-test/${id}`);
  },
  getLatestInsurance: async () => {
    return await api.get('/vehicle-insurance/latest-all');
  },
  getInsuranceById: async (id) => {
    return await api.get(`/vehicle-insurance/${id}`);
  },
  getLatestRevenueLicences: async () => {
    return await api.get('/vehicle-revenue-licences/latest-all');
  },
  getRevenueLicenceById: async (id) => {
    return await api.get(`/vehicle-revenue-licences/${id}`);
  },
  getInsuranceHistory: async (numberPlate) => {
    try {
      return await api.get(`/vehicle-insurance/history/${numberPlate}`);
    } catch (error) {
      throw error;
    }
  },
  getEmissionTestHistory: async (numberPlate) => {
    try {
      return await api.get(`/vehicle-emission-test/history/${numberPlate}`);
    } catch (error) {
      throw error;
    }
  },
  getRevenueLicenceHistory: async (numberPlate) => {
    try {
      return await api.get(`/vehicle-revenue-licences/history/${numberPlate}`);
    } catch (error) {
      throw error;
    }
  },
  getEmissionTest: async (numberPlate) => {
    try {
      return await api.get(`/vehicle-emission-test/latest/${numberPlate}`);
    } catch (error) {
      throw error;
    }
  },
  getInsurance: async (numberPlate) => {
    try {
      return await api.get(`/vehicle-insurance/latest/${numberPlate}`);
    } catch (error) {
      throw error;
    }
  },
  getRevenueLicence: async (numberPlate) => {
    try {
      return await api.get(`/vehicle-revenue-licences/latest/${numberPlate}`);
    } catch (error) {
      throw error;
    }
  },
  getAllVehicleStatuses: async () => {
    return await api.get('/vehicle-statuses/all');
  },
  createVehicleStatus: async (payload) => {
    return await api.post('/vehicle-statuses/add', payload);
  },
  deleteVehicleStatus: async (id) => {
    return await api.delete(`/vehicle-statuses/${id}`);
  },
  getAllVehicleGearTypes: async () => {
    return await api.get('/vehicle-gear-types/all');
  },
  createVehicleGearType: async (payload) => {
    return await api.post('/vehicle-gear-types/add', payload);
  },
  deleteVehicleGearType: async (id) => {
    return await api.delete(`/vehicle-gear-types/${id}`);
  },
  getAllVehicleFuelTypes: async () => {
    return await api.get('/vehicle-fuel-types/all');
  },
  createVehicleFuelType: async (payload) => {
    return await api.post('/vehicle-fuel-types/add', payload);
  },
  deleteVehicleFuelType: async (id) => {
    return await api.delete(`/vehicle-fuel-types/${id}`);
  },
  getAllVehicleConditions: async () => {
    return await api.get('/vehicle-conditions/all');
  },
  createVehicleCondition: async (payload) => {
    return await api.post('/vehicle-conditions/add', payload);
  },
  deleteVehicleCondition: async (id) => {
    return await api.delete(`/vehicle-conditions/${id}`);
  },
  getAllVehicleClasses: async () => {
    return await api.get('/vehicle-classes/all');
  },
  createVehicleClass: async (payload) => {
    return await api.post('/vehicle-classes/add', payload);
  },
  deleteVehicleClass: async (id) => {
    return await api.delete(`/vehicle-classes/${id}`);
  },
  addDepartment: async (payload) => {
    return await api.post('/department/add', payload);
  },
  getDepartments: async (pageNo, payload) => {
    return await api.post(`/department/get/${pageNo}`, payload);
    },

  getRecurringBookings: async (pageNo) => {
    try {
      const response = await api.get('/vehicle-booking/recurring', {
        params: { pageNo },
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }, // Ensure token is included
      });
      return response; // Return the full response object
    } catch (error) {
      throw error;
    }
  },

  cancelRecurringBooking: async (id) => {
    try {
      const response = await api.put(`/vehicle-booking/recurring/cancel/${id}`, {}, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getRecurringBookingById: async (id) => {
    try {
      const response = await api.get(`/vehicle-booking/recurring/${id}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateRecurringBooking: async (id, payload) => {
    try {
      const response = await api.put(`/vehicle-booking/recurring/update/${id}`, payload, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  updateMergedGroupDetails: async (groupId, payload) => {
  try {
    const response = await api.put(`/vehicle-booking/update-merged-group/${groupId}`, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
        Accept: 'application/json, text/plain, */*',
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
},
getCancelledBookings: async (pageNo = 1) => {
  try {
    const response = await api.get('/vehicle-booking/cancelled', {
      params: { pageNo },
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
},
addBuilding: async (payload) => {
  try {
    const response = await api.post('/buildings', payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
},

getBuildingById: async (id) => {
  try {
    const response = await api.get(`/buildings/${id}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
    return response;
  } catch (error) {
    throw error;
  }
},

getBuildingByName: async (name) => {
  try {
    const response = await api.get('/buildings', {
      params: { name },
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
    return response;
  } catch (error) {
    throw error;
  }
},

getAllBuildings: async () => {
  try {
    const response = await api.get('/buildings/all', {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
    return response;
  } catch (error) {
    throw error;
  }
},

getBuildingsByLocationId: async (locationId) => {
  try {
    const response = await api.get(`/buildings/location/${locationId}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
    return response;
  } catch (error) {
    throw error;
  }
},

updateBuilding: async (payload) => {
  try {
    const response = await api.put('/buildings', payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
},

deleteBuilding: async (id) => {
  try {
    const response = await api.delete(`/buildings/${id}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
    return response;
  } catch (error) {
    throw error;
  }
},
// ----- Floor APIs (Key Management) -----
createFloor: async (payload) => {
  try {
    // payload: AddFloorRequest
    const res = await api.post('/floors', payload);
    return res;
  } catch (error) {
    throw error;
  }
},

getFloorById: async (id) => {
  try {
    const res = await api.get(`/floors/${id}`);
    return res;
  } catch (error) {
    throw error;
  }
},

getFloorByName: async (name) => {
  try {
    const res = await api.get(`/floors/name/${encodeURIComponent(name)}`);
    return res;
  } catch (error) {
    throw error;
  }
},

getAllFloors: async () => {
  try {
    const res = await api.get('/floors/all');
    return res;
  } catch (error) {
    throw error;
  }
},

getFloorsByBuildingId: async (buildingId) => {
  try {
    const res = await api.get(`/floors/building/${buildingId}`);
    return res;
  } catch (error) {
    throw error;
  }
},

updateFloor: async (payload) => {
  try {
    // payload: UpdateFloorRequest
    const res = await api.put('/floors/update', payload);
    return res;
  } catch (error) {
    throw error;
  }
},

deleteFloor: async (id) => {
  try {
    const res = await api.delete(`/floors/${id}`);
    return res;
  } catch (error) {
    throw error;
  }
},

// ----- Room APIs (Key Management) -----
addRoom: async (payload) => {
  try {
    const res = await api.post('/rooms/add', payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
      },
    });
    return res;
  } catch (error) {
    throw error;
  }
},

getRooms: async (pageNo = '1', payload = { filterType: '', filterValue: '', date: '' }) => {
  try {
    const res = await api.post(`/rooms/get/${pageNo}`, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
      },
    });
    return res;
  } catch (error) {
    throw error;
  }
},

getRoomById: async (id) => {
  try {
    const res = await api.get(`/rooms/${id}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
    return res;
  } catch (error) {
    throw error;
  }
},

getRoomByName: async (name) => {
  try {
    const res = await api.get(`/rooms/name/${encodeURIComponent(name)}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
    return res;
  } catch (error) {
    throw error;
  }
},

getRoomsByFloorId: async (floorId) => {
  try {
    const res = await api.get(`/rooms/floor/${floorId}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
    return res;
  } catch (error) {
    throw error;
  }
},

updateRoom: async (payload) => {
  try {
    const res = await api.put('/rooms/update', payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
      },
    });
    return res;
  } catch (error) {
    throw error;
  }
},

deleteRoom: async (id) => {
  try {
    const res = await api.delete(`/rooms/${id}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
    return res;
  } catch (error) {
    throw error;
  }
},
// ----- end Room APIs -----

// ----- Door APIs (Key Management) -----
addDoor: async (payload) => {
  try {
    const res = await api.post('/doors/add', payload);
    return res;
  } catch (error) {
    throw error;
  }
},

getDoorById: async (id) => {
  try {
    const res = await api.get('/doors/get', { params: { id } });
    return res;
  } catch (error) {
    throw error;
  }
},

getDoorByName: async (name) => {
  try {
    const res = await api.get('/doors/get-name', { params: { name } });
    return res;
  } catch (error) {
    throw error;
  }
},

getAllDoors: async () => {
  try {
    const res = await api.get('/doors/get-all');
    return res;
  } catch (error) {
    throw error;
  }
},

getDoorsByRoomId: async (roomId) => {
  try {
    const res = await api.get('/doors/get-by-roomId', { params: { roomId } });
    return res;
  } catch (error) {
    throw error;
  }
},

updateDoor: async (payload) => {
  try {
    const res = await api.put('/doors/update', payload);
    return res;
  } catch (error) {
    throw error;
  }
},

deleteDoor: async (id) => {
  try {
    const res = await api.delete(`/doors/delete/${id}`);
    return res;
  } catch (error) {
    throw error;
  }
},
// ----- Key APIs (Key Management) -----

addKey: async (payload) => {
  try {
    // payload: AddKeyRequest
    const res = await api.post('/key/add', payload);
    return res;
  } catch (error) {
    throw error;
  }
},

getKeys: async (pageNo = 1, payload) => {
  try {
    // payload: GetByPatternRequest
    const res = await api.post(`/key/get/${pageNo}`, payload);
    return res;
  } catch (error) {
    throw error;
  }
},

getKeyById: async (keyId) => {
  try {
    const res = await api.get(`/key/getById/${keyId}`);
    return res;
  } catch (error) {
    throw error;
  }
},

getKeyByKeyCode: async (keyCode) => {
  try {
    const res = await api.get(`/key/getByKeyCode/${encodeURIComponent(keyCode)}`);
    return res;
  } catch (error) {
    throw error;
  }
},

getKeysByRoomId: async (roomId) => {
  try {
    const res = await api.get(`/key/getByRoomId/${roomId}`);
    return res;
  } catch (error) {
    throw error;
  }
},

  updateKey: async (payload) => {
    try {
      const res = await api.put('/key/update', payload);
      return res;
    } catch (error) {
      
      throw error;
    }
  },

deleteKey: async (keyId) => {
  try {
    const res = await api.delete(`/key/delete/${keyId}`);
    return res;
  } catch (error) {
    throw error;
  }
},

rebundleKeys: async (payload) => {
  try {
    // payload: RebundleKeysRequest
    const res = await api.post('/key/rebundle', payload);
    return res;
  } catch (error) {
    throw error;
  }
},
// ----- Keys by Door -----
getKeysByDoorId: async (doorId) => {
  try {
    const res = await api.get(`/key/getByDoorId/${doorId}`);
    return res;
  } catch (error) {
    throw error;
  }
},
// ----- Key Allocation APIs -----

// POST /key-allocation/available-keys/{pageNo}
getAvailableKeys: async (pageNo = 1, payload) => {
  try {
    // payload: GetByPatternRequest { filterType, filterValue, date, ... }
    const res = await api.post(`/key-allocation/available-keys/${pageNo}`, payload);
    return res;
  } catch (error) {
    throw error;
  }
},

// POST /key-allocation/mark-handover
markHandover: async (payload) => {
  try {
    // payload: MarkHandoverRequest
    const res = await api.post('/key-allocation/mark-handover', payload);
    return res;
  } catch (error) {
    throw error;
  }
},

// POST /key-allocation/handover-keys/{pageNo}
getAllHandoverKeys: async (pageNo = 1, payload) => {
  try {
    // payload: GetByPatternRequest
    const res = await api.post(`/key-allocation/handover-keys/${pageNo}`, payload);
    return res;
  } catch (error) {
    throw error;
  }
},

// GET /key-allocation/handover-keys/{id}
getHandoverKeyById: async (id) => {
  try {
    const res = await api.get(`/key-allocation/handover-keys/${id}`);
    return res;
  } catch (error) {
    throw error;
  }
},

// POST /key-allocation/mark-returned
markReturned: async (payload) => {
  try {
    // payload: MarkReturnRequest
    const res = await api.post('/key-allocation/mark-returned', payload);
    return res;
  } catch (error) {
    throw error;
  }
},



// ----- Key Request APIs -----

// POST /Key-request/request
requestKey: async (payload) => {
  try {
    // payload: RequestKey
    const res = await api.post('/Key-request/request', payload);
    return res;
  } catch (error) {
    throw error;
  }
},

// POST /Key-request/get-all?pageNo=...
getAllKeyRequests: async (pageNo = '1', payload) => {
  try {
    // payload: GetByPatternRequest
    const res = await api.post('/Key-request/get-all', payload, { params: { pageNo } });
    return res;
  } catch (error) {
    throw error;
  }
},

// POST /Key-request/get-user-created?pageNo=...
getUserCreatedKeyRequests: async (pageNo = '1', payload) => {
  try {
    // payload: GetByPatternRequest
    const res = await api.post('/Key-request/get-user-created', payload, { params: { pageNo } });
    return res;
  } catch (error) {
    throw error;
  }
},

// GET /Key-request/{id}
getKeyRequestById: async (id) => {
  try {
    const res = await api.get(`/Key-request/${id}`);
    return res;
  } catch (error) {
    throw error;
  }
},

// POST /Key-request/assign-approvers
assignKeyApprovers: async (payload) => {
  try {
    // payload: AssignApproversRequest
    const res = await api.post('/Key-request/assign-approvers', payload);
    return res;
  } catch (error) {
    throw error;
  }
},

// POST /Key-request/{id}/approve
approveKeyRequest: async (id, payload) => {
  try {
    // payload: ApprovalKeyRequest
    const res = await api.post(`/Key-request/approve/${id}`, payload);
    return res;
  } catch (error) {
    throw error;
  }
},

// GET /Key-request/pending?pageNo=...
getPendingApprovalKeyRequests: async (pageNo = '1') => {
  try {
    const res = await api.get('/Key-request/pending', { params: { pageNo } });
    return res;
  } catch (error) {
    throw error;
  }
},
// ----- Approvers Management APIs -----

// POST /Key-request/approvers
getAllApprovers: async (payload) => {
  try {
    // payload: GetByPatternRequest
    const res = await api.post('/Key-request/approvers', payload);
    return res;
  } catch (error) {
    throw error;
  }
},

// POST /Key-request/deactivate-approver
deactivateApprover: async (payload) => {
  try {
    // payload: DeactivateApproverRequest
    const res = await api.post('/Key-request/deactivate-approver', payload);
    return res;
  } catch (error) {
    throw error;
  }
},

// GET /Key-request/approved-vehicle-bookings-keys
getApprovedVehicleBookingsWithKeys: async () => {
  try {
    const res = await api.get('/Key-request/approved-vehicle-bookings-keys');
    return res;
  } catch (error) {
    throw error;
  }
},
// GET /key/getByVehicleId/{vehicleId}
getKeysByVehicleId: async (vehicleId) => {
  try {
    const res = await api.get(`/key/getByVehicleId/${vehicleId}`);
    return res; // ApiResponse<KeyDto[]>
  } catch (error) {
    throw error;
  }
},
// ----- Letter APIs -----

addLetter: async (payload) => {
  try {
    // payload: AddLetterRequest
    const res = await api.post('/letters/add', payload);
    return res;
  } catch (error) {
    throw error;
  }
},

getLetterById: async (letterId) => {
  try {
    const res = await api.get(`/letters/getById/${letterId}`);
    return res;
  } catch (error) {
    throw error;
  }
},

getAllLetters: async (pageNo = 1, payload) => {
  try {
    // payload: GetByPatternRequest
    const res = await api.post(`/letters/get/${pageNo}`, payload);
    return res;
  } catch (error) {
    throw error;
  }
},

updateLetter: async (payload) => {
  try {
    // payload: UpdateLetterRequest
    const res = await api.put('/letters/update', payload);
    return res;
  } catch (error) {
    throw error;
  }
},

deleteLetter: async (letterId) => {
  try {
    const res = await api.delete(`/letters/delete/${letterId}`);
    return res;
  } catch (error) {
    throw error;
  }
},

handoverLetters: async (payload) => {
  try {
    // payload: HandoverLetters
    const res = await api.post('/letters/handover', payload);
    return res;
  } catch (error) {
    throw error;
  }
},

getLettersForRelatedDepartments: async (pageNo = 1, payload) => {
  try {
    // payload: GetByPatternRequest
    const res = await api.post(`/letters/getByDepartment/${pageNo}`, payload);
    return res;
  } catch (error) {
    throw error;
  }
},
getUnreturnedKeys: async () => {
  try {
    const res = await api.get('/key/unreturned-keys');
    return res;
  } catch (error) {
    throw error;
  }
},
getUnreturnedKeys: async () => {
  try {
    const res = await api.get('/key/unreturned-keys');
    return res;
  } catch (error) {
    throw error;
  }
},
// ----- Parking Slot APIs (Visitor Management) -----
addParkingSlot: async (payload) => {
  try {
    const res = await api.post('/parking-slots/add', payload, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    });
    return res;
  } catch (error) {
    throw error;
  }
},

// WARNING: GET with body is unusual. Axios allows sending `data` with GET, but many proxies drop it.

// Note: Your backend uses POST for a read
getParkingSlotById: async (id) => {
  try {
    const res = await api.get(`/parking-slots/get-by-id/${id}`, null, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    });
    return res;
  } catch (error) {
    throw error;
  }
},

updateParkingSlot: async (payload) => {
  try {
    const res = await api.put('/parking-slots/update', payload, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    });
    return res;
  } catch (error) {
    throw error;
  }
},

deleteParkingSlot: async (id) => {
  try {
    const res = await api.delete(`/parking-slots/delete/${id}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    });
    return res;
  } catch (error) {
    throw error;
  }
},
// apiDefinitions.ts
getAllParkingSlots: async (pageNo, payload) => {
    try {
      const res = await api.post(`/parking-slots/get-all/${pageNo}`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json',
        },
      });
      return res;
    } catch (error) {
      throw error;
    }
  },
  // ----- Visitor Management APIs -----
addVisitor: async (payload) => {
  try {
    const res = await api.post('/visitor/add', payload, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
    return res;
  } catch (error) {
    throw error;
  }
},

getVisitors: async (pageNo = '1', payload) => {
  try {
    // POST /visitor/get/{pageNo} with filter body (GetByPatternRequest)
    const res = await api.post(`/visitor/get/${pageNo}`, payload, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
    return res;
  } catch (error) {
    throw error;
  }
},

getVisitorById: async (visitorRequestId) => {
  try {
    // GET /visitor/get/{visitorRequestId}
    const res = await api.get(`/visitor/get/${visitorRequestId}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
    return res;
  } catch (error) {
    throw error;
  }
},

updateVisitor: async (payload) => {
  try {
    const res = await api.put('/visitor/update', payload, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
    return res;
  } catch (error) {
    throw error;
  }
},

deleteVisitor: async (requestId) => {
  try {
    const res = await api.delete(`/visitor/delete/${requestId}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
    return res;
  } catch (error) {
    throw error;
  }
},

getPendingApprovalVisitors: async (pageNo = '1') => {
  try {
    const res = await api.post('/visitor/pending-approval', {
      params: { pageNo },
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
    return res;
  } catch (error) {
    throw error;
  }
},

approveVisitor: async (payload) => {
  try {
    const res = await api.post('/visitor/approve', payload, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
    return res;
  } catch (error) {
    throw error;
  }
},

finalApproveVisitor: async (payload) => {
  try {
    const res = await api.post('/visitor/final-approve', payload, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
    return res;
  } catch (error) {
    throw error;
  }
},
getUserCreatedVisitors: async (pageNo = '1', payload = {}) => {
  try {
    const res = await api.post(`/visitor/user-created/${pageNo}`, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
      },
    });
    return res; // -> ApiResponse<List<VisitorRequestDataDto>>
  } catch (error) {
    throw error;
  }
},
// ----- Visitor Management (status lists) -----
getRejectedVisitors: async () => {
  try {
    const res = await api.get('/visitor/rejected', {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
    return res; // ApiResponse<VisitorRequestDataDto[]>
  } catch (error) {
    throw error;
  }
},

getFinalRejectedVisitors: async () => {
  try {
    const res = await api.get('/visitor/final-rejected', {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
    return res; // ApiResponse<VisitorRequestDataDto[]>
  } catch (error) {
    throw error;
  }
},

getApprovedVisitors: async () => {
  try {
    const res = await api.get('/visitor/approved', {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
    return res; // ApiResponse<VisitorRequestDataDto[]>
  } catch (error) {
    throw error;
  }
},
// ----- Visitor Management: Mark In / Out -----
markVisitorIn: async (payload) => {
  try {
    const res = await api.put('/visitor/mark-in', payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
      },
    });
    return res; // ApiResponse<List<Void>>
  } catch (error) {
    throw error;
  }
},

markVisitorOut: async (payload) => {
  try {
    const res = await api.put('/visitor/mark-out', payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
      },
    });
    return res; // ApiResponse<List<Void>>
  } catch (error) {
    throw error;
  }
},
allocateParkingSlotPermanently: (parkingSlotId, vehicleId) =>
  api.post('/parking-slots/allocate-permanently', null, {
    params: { parkingSlotId, vehicleId },
  }),

removePermanentlyAllocatedParkingSlot: (vehicleId) =>
  api.post('/parking-slots/remove-allocated', null, {
    params: { vehicleId },
  }),
  // ----- Windows -----
addWindow: (payload) => api.post('/windows/add', payload),

updateWindow: (payload) => api.put('/windows/update', payload),

deleteWindow: (id) => api.delete(`/windows/delete/${id}`),

getWindowById: (id) => api.get(`/windows/get/${id}`),

getAllWindows: (pageNo = 1, payload = {}) =>
  api.post(`/windows/get-all?pageNo=${pageNo}`, payload),
// items
getAllItems: (pageNo = 1, payload = {}) =>
  api.post(`/items/getAll/${pageNo}`, payload),
getItemById: (id) => api.get(`/items/get/${id}`),
createItem: (payload) => api.post('/items/add', payload),
updateItem: (payload) => api.put('/items/update', payload),
deleteItem: (id) => api.delete(`/items/delete/${id}`),

// item-brands
getAllItemBrands: (pageNo = 1, payload = {}) =>
  api.post(`/item-brands/get-all?pageNo=${pageNo}`, payload),
getItemBrandById: (id) => api.get(`/item-brands/get/${id}`),
createItemBrand: (payload) => api.post('/item-brands/add', payload),
updateItemBrand: (payload) => api.put('/item-brands/update', payload),
deleteItemBrand: (id) => api.delete(`/item-brands/delete/${id}`),
// item-types
getAllItemTypes: (pageNo = 1, payload = {}) =>
  api.post(`/item-types/get-all/${pageNo}`, payload),
getItemTypeById: (id) => api.get(`/item-types/get/${id}`),
addItemType: (payload) => api.post('/item-types/add', payload),
updateItemType: (payload) => api.put('/item-types/update', payload),
deleteItemType: (id) => api.delete(`/item-types/delete/${id}`),

// maintenance-tasks
getAllMaintenanceTasks: (pageNo = 1, payload = {}) =>
  api.post(`/maintenanceTask/get-all/1`, payload),
getMaintenanceTaskById: (id) =>
  api.get(`/maintenanceTask/get/${id}`),
createMaintenanceTask: (payload) =>
  api.post('/maintenanceTask/add', payload),
updateMaintenanceTask: (payload) =>
  api.put('/maintenanceTask/update', payload),
deleteMaintenanceTask: (id) =>
  api.delete(`/maintenanceTask/delete/${id}`),

// job-cards
getAllJobCards: (pageNo = 1, payload = {}) =>
  api.post(`/jobCard/get-all/1`, payload),
getJobCardById: (id) =>
  api.get(`/jobCard/get/${id}`),
createJobCard: (payload) =>
  api.post('/jobCard/add', payload),
updateJobCard: (payload) =>
  api.put('/jobCard/update', payload),
deleteJobCard: (id) =>
  api.delete(`/jobCard/delete/${id}`),

// status update
changeJobCardStatus: (payload) =>
  api.post('/jobCard/change-jobCard-status', payload),

// filter by responsible person
getJobCardsByResponsiblePerson: (pageNo = 1, payload = {}) =>
  api.post(`/jobCard/get-job-cards-related-responsible-person/1`, payload),

// filter by accountable person
getJobCardsByAccountablePerson: (pageNo = 1, payload = {}) =>
  api.post(`/jobCard/get-job-cards-related-accountable-person/${pageNo}`, payload),

// daily summary
getDailyJobCardSummary: () =>
  api.get('/jobCard/get-daily-summery'),

// Change job card status
changeJobCardStatus: (payload) =>
  api.post('/jobCard/change-jobCard-status', payload),

// Filter job cards by responsible person
getJobCardsByResponsiblePerson: (pageNo = 1, payload = {}) =>
  api.post(`/jobCard/get-job-cards-related-responsible-person/${pageNo}`, payload),

// Filter job cards by accountable person
getJobCardsByAccountablePerson: (pageNo = 1, payload = {}) =>
  api.post(`/jobCard/get-job-cards-related-accountable-person/${pageNo}`, payload),

// Get daily job card summary
getDailyJobCardSummary: () =>
  api.get('/jobCard/get-daily-summery'),
// item-service-cards
getAllItemServiceCards: (pageNo =0, payload = {}) =>
  api.post(`/item-service-cards/get-all/${pageNo}`, payload),
getItemServiceCardById: (id) =>
  api.get(`/item-service-cards/${id}`),
addItemServiceCard: (payload) =>
  api.post('/item-service-cards/add', payload),
updateItemServiceCard: (payload) =>
  api.put('/item-service-cards/update', payload),
deleteItemServiceCard: (id) =>
  api.delete(`/item-service-cards/delete/${id}`),
finalizeServiceCard: (payload) =>
  api.post('/item-service-cards/finalize-service-card', payload),
getBookingDashboardCounts:() =>
  api.get(`/vehicle-booking/get-vehicle-booking-counts`),
getAllocatedKeyCounts:() =>
  api.get(`/key-allocation/get-unreturned-keys-count`),

getVisitorRequestCounts:() =>
  api.get(`/visitor/get-visitor-request-count`),
// ----- Employee Vehicle APIs -----
addEmployeeVehicle: async (payload) => {
  try {
    // POST /employee-vehicle/add
    return await api.post('/employee-vehicle/add', payload)
  } catch (error) {
    throw error
  }
},

updateEmployeeVehicle: async (payload) => {
  try {
    // PUT /employee-vehicle/update
    return await api.put('/employee-vehicle/update', payload)
  } catch (error) {
    throw error
  }
},

deleteEmployeeVehicle: async (vehicleId) => {
  try {
    // DELETE /employee-vehicle/delete/{vehicleId}
    return await api.delete(`/employee-vehicle/delete/${vehicleId}`)
  } catch (error) {
    throw error
  }
},

getAllEmployeeVehicles: async (pageNo = 0, pageSize = 10, payload = {}) => {
  try {
    // POST /employee-vehicle/get-all?pageNo=0&pageSize=10
    return await api.post('/employee-vehicle/get-all', payload, {
      params: { pageNo: String(pageNo), pageSize: String(pageSize) },
    })
  } catch (error) {
    throw error
  }
},

getEmployeeVehicleById: async (vehicleId) => {
  try {
    // GET /employee-vehicle/get/{vehicleId}
    return await api.get(`/employee-vehicle/get/${vehicleId}`)
  } catch (error) {
    throw error
  }
},

// ----- Gate Management APIs -----
getCameras: async (pageNo = 0, pageSize = 20, payload = {}) => {
  try {
    return await api.post('/camera/get-all', payload, {
      params: { pageNo: String(pageNo), pageSize: String(pageSize) },
    });
  } catch (error) { throw error; }
},
getCameraById: async (id) => {
  try {
    return await api.get(`/camera/get-by-id/${id}`);
  } catch (error) { throw error; }
},
createCamera: async (payload) => {
  try {
    return await api.post('/camera/create', payload);
  } catch (error) { throw error; }
},
updateCamera: async (payload) => {
  try {
    return await api.post('/camera/update', payload);
  } catch (error) { throw error; }
},
deleteCamera: async (id) => {
  try {
    return await api.delete(`/camera/delete/${id}`);
  } catch (error) { throw error; }
},

getRelayDevices: async (pageNo = 0, pageSize = 20, payload = {}) => {
  try {
    return await api.post('/relay-device/get-all', payload, {
      params: { pageNo: String(pageNo), pageSize: String(pageSize) },
    });
  } catch (error) { throw error; }
},
getRelayDeviceById: async (id) => {
  try {
    return await api.get(`/relay-device/get-by-id/${id}`);
  } catch (error) { throw error; }
},
createRelayDevice: async (payload) => {
  try {
    return await api.post('/relay-device/create', payload);
  } catch (error) { throw error; }
},
updateRelayDevice: async (payload) => {
  try {
    return await api.post('/relay-device/update', payload);
  } catch (error) { throw error; }
},
deleteRelayDevice: async (id) => {
  try {
    return await api.delete(`/relay-device/delete/${id}`);
  } catch (error) { throw error; }
},

getGates: async (pageNo = 0, pageSize = 20, payload = {}) => {
  try {
    return await api.post('/gate/get-all', payload, {
      params: { pageNo: String(pageNo), pageSize: String(pageSize) },
    });
  } catch (error) { throw error; }
},
getGateById: async (id) => {
  try {
    return await api.get(`/gate/get-by-id/${id}`);
  } catch (error) { throw error; }
},
createGate: async (payload) => {
  try {
    return await api.post('/gate/create', payload);
  } catch (error) { throw error; }
},
updateGate: async (payload) => {
  try {
    return await api.post('/gate/update', payload);
  } catch (error) { throw error; }
},
deleteGate: async (id) => {
  try {
    return await api.delete(`/gate/delete/${id}`);
  } catch (error) { throw error; }
},
  // Gate Control & OAuth
  getEwelinkToken: async () => {
    try {
      return await api.get('/gatecontrol/ewelink/oauth/token/latest');
    } catch (error) { throw error; }
  },
  openGate: async (gateId, duration) => {
    try {
      return await api.get(`/gatecontrol/relay/open/${gateId}`, {
        params: { durationSeconds: duration }
      });
    } catch (error) { throw error; }
  },
  turnOnGate: async (gateId) => {
    try {
      return await api.get(`/gatecontrol/relay/on/${gateId}`);
    } catch (error) { throw error; }
  },
  turnOffGate: async (gateId) => {
    try {
      return await api.get(`/gatecontrol/relay/off/${gateId}`);
    } catch (error) { throw error; }
  },
};


export default apiDefinitions;